// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"9b4825fe","279":"23a633e4","807":"8bda968c","932":"46ca6a21","951":"43b08872"}[chunkId] + ".chunk.js";
};